import { Injectable } from '@angular/core';

type Translation = Object | null;
type TranslationLoadedMap = Record<string, { translation: Translation; isLoaded: boolean }>;

@Injectable({ providedIn: 'root' })
export class MissingTranslationHelperService {
  private translationLoadedMap: TranslationLoadedMap = {};

  setLoadedStatus(scope: string, translation: Translation): void {
    this.translationLoadedMap[scope] = {
      translation,
      isLoaded: true,
    };
  }

  isScopeLoaded(scope: string): boolean {
    return this.translationLoadedMap[scope]?.isLoaded;
  }

  getScopeTranslation(scope: string): Translation {
    return this.translationLoadedMap[scope]?.translation;
  }
}
